import {IEnvironmentSessionStorageService} from "./environment-session-storage.service.interface";
import {EnvSessionStorageKeys} from "./environment-session-storage-keys";
import {StorageServiceBase} from "../storage-service-base";
import {IServiceFactory} from "../../service-factory.interface";
import {UndefinedString} from "../../../types/nullable-types";

/**
 * Appends the environment type to the keys
 */
export class EnvironmentSessionStorageService extends StorageServiceBase<EnvSessionStorageKeys> implements IEnvironmentSessionStorageService {

    constructor(services: IServiceFactory) {
        super(sessionStorage, services);
    }

    protected get _storageName(): string {
        return "environmentSessionStorage";
    }

    protected _composeKey(key: EnvSessionStorageKeys, discriminator: UndefinedString): string {
        if(discriminator) {
            return `${key}.${this.services.configuration.currentEnvironmentType}.${discriminator}`;
        } else {
            return `${key}.${this.services.configuration.currentEnvironmentType}`;
        }
    }

    protected _clearLargeStorageConsumersData() {
        this.services.largeStorageConsumersManager.clearSessionStorageConsumers();
    }

}